import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'
import { InfluencerBody } from '../../../../../interface/chronique.interface'

const PostChroniqueur = (
  influencer_datas: InfluencerBody[],
  id_ean: string,
) => {
  return apiInstance.post(ApiPathConfig.CHRONIQUEUR, {
    influencer_datas,
    id_ean,
  })
}

export default PostChroniqueur
